import { apiClient } from "../apiClient";
import { API_ENDPOINTS } from "@repo/constants";
import { AxiosError } from "axios";
import { GetSubscriptionRequest, GetSubscriptionResponse, InsertSubscriptionRequest, InsertSubscriptionResponse, UpdateSubscriptionRequest, UpdateSubscriptionResponse } from "@repo/types";

export const subscriptionPlanList = async (
  payload: Partial<GetSubscriptionRequest>,
): Promise<GetSubscriptionResponse> => {
  try {
    const response = await apiClient.post<GetSubscriptionResponse>(
      API_ENDPOINTS.subscriptionPlanList,
      payload,
    );
    return response.data;
  } catch (err) {
    const error = err as AxiosError<any>;
    console.error("Error fetching subscription plan list:", error);
    const apiMessage =
      error.response?.data?.Message ||
      error.message ||
      "An unexpected error occurred";
    return {
      Success: false,
      Message: apiMessage,
      StatusCode: 500,
      Data: [],
    };
  }
};

export const insertSubscrtiptionPlan = async (
  payload: Partial<InsertSubscriptionRequest>,
): Promise<InsertSubscriptionResponse> => {
  try {
    console.log("Subscription Plan Register payload", payload);
    const response = await apiClient.post<InsertSubscriptionResponse>(
      API_ENDPOINTS.insertSubscription,
      payload,
    );
    return response.data;
  } catch (err) {
    const error = err as AxiosError<any>;
    console.error("Error inserting subscription plan:", error);
    const apiMessage =
      error.response?.data?.Message ||
      error.message ||
      "An unexpected error occurred";
    return { Success: false, Message: apiMessage, StatusCode: 500 };
  }
};

export const updateSubscriptionPlan = async (
  payload: Partial<UpdateSubscriptionRequest>,
): Promise<UpdateSubscriptionResponse> => {
  try {
    const response = await apiClient.put<UpdateSubscriptionResponse>(
      API_ENDPOINTS.updateSubscriptionPlan,
      payload,
    );
    return response.data;
  } catch (err) {
    const error = err as AxiosError<any>;
    console.error("Error updating subscription plan:", error);
    const apiMessage =
      error.response?.data?.Message ||
      error.message ||
      "An unexpected error occurred";
    return { Success: false, Message: apiMessage, StatusCode: 500 };
  }
};